import { render, staticRenderFns } from "./GestionNormas.vue?vue&type=template&id=f0bb2960&scoped=true&"
import script from "./GestionNormas.vue?vue&type=script&lang=js&"
export * from "./GestionNormas.vue?vue&type=script&lang=js&"
import style0 from "./GestionNormas.vue?vue&type=style&index=0&id=f0bb2960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bb2960",
  null
  
)

export default component.exports